import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import { UploadOrderDocumentsPopover } from "./upload-order-documents";

@NgModule({
  declarations: [UploadOrderDocumentsPopover],
  imports: [
    IonicPageModule.forChild(UploadOrderDocumentsPopover),
    HttpClientModule,
    ComponentsModule,
    CommonComponentsModule,
    TranslateModule.forChild(),
    NgSelectModule,
  ],
})
export class UploadOrderDocumentsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/order-managment/upload-order-documents/upload-order-documents.module.ts